import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { KYMW7100Component } from "./kymw7100.component";
import { CommonModule } from "@angular/common";
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { GetBundleCatalogMediumService } from "./api-services/get-bundle-catalog-medium.service";
import { RegistBundleCatalogRoundInfoService } from "./api-services/regist-bundle-catalog-round-info.service";
import { GetBundleCatalogRoundInfoService } from "./api-services/get-bundle-catalog-round-info.service";
import { DeleteBundleCatalogRoundInfoService } from "./api-services/delete-bundle-catalog-round-info.service";

/**
 * 束ね企画回設定画面 モジュール設定クラス
 *
 * @export KYMW7100Module
 * @class KYMW7100Module
 */
@NgModule({
  imports: [
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    CommonModule,
    WjNavModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [
    KYMW7100Component,
  ],
  providers: [
    GetBundleCatalogMediumService,
    GetBundleCatalogRoundInfoService,
    RegistBundleCatalogRoundInfoService,
    DeleteBundleCatalogRoundInfoService,
  ]
})
export class KYMW7100Module {
}